import {AdminPermission, AdminPermissions} from './admin-permissions';

export interface AdminPermissionDefinition {
    permission: AdminPermission;
    label: string;
    description: string;
    group: string;
}

export const AdminPermissionDefinitions: readonly AdminPermissionDefinition[] = [
    {
        permission: AdminPermissions.ViewServerLogs,
        label: 'View server logs',
        description: 'Open Server Logs and search application log messages.',
        group: 'Data access'
    },
    {
        permission: AdminPermissions.ViewCars,
        label: 'View cars',
        description: 'Open the Cars page and view car and driver details.',
        group: 'Data access'
    },
    {
        permission: AdminPermissions.ViewMap,
        label: 'View map',
        description: 'Open the live map and view active cars and orders.',
        group: 'Data access'
    },
    {
        permission: AdminPermissions.ViewOrders,
        label: 'View orders',
        description: 'Open the Orders page and inspect order details and locations.',
        group: 'Data access'
    },
    {
        permission: AdminPermissions.ViewPos,
        label: 'View POS',
        description: 'Open the POS page and inspect terminal configuration.',
        group: 'Data access'
    },
    {
        permission: AdminPermissions.ViewVouchers,
        label: 'View vouchers',
        description: 'Open the Vouchers page and inspect pending vouchers.',
        group: 'Data access'
    },
    {
        permission: AdminPermissions.ViewAirportCars,
        label: 'View airport cars',
        description: 'Open the airport queue and inspect queued cars.',
        group: 'Data access'
    },
    {
        permission: AdminPermissions.ViewKioskLogs,
        label: 'View kiosk logs',
        description: 'View recent airport kiosk system logs.',
        group: 'Data access'
    },
    {
        permission: AdminPermissions.ViewUsers,
        label: 'View users',
        description: 'Open this page and view administrator accounts.',
        group: 'User management'
    },
    {
        permission: AdminPermissions.ExportData,
        label: 'Export data',
        description: 'Export available administrative data to Excel.',
        group: 'Cars'
    },
    {
        permission: AdminPermissions.UpdateCar,
        label: 'Update cars',
        description: 'Change car services, package and tariff settings.',
        group: 'Cars'
    },
    {
        permission: AdminPermissions.UnpairCarDevice,
        label: 'Unpair car devices',
        description: 'Disconnect a paired device from a car.',
        group: 'Cars'
    },
    {
        permission: AdminPermissions.SuspendCar,
        label: 'Suspend cars',
        description: 'Suspend a car from providing service.',
        group: 'Cars'
    },
    {
        permission: AdminPermissions.UnsuspendCar,
        label: 'Unsuspend cars',
        description: 'Remove an active car suspension.',
        group: 'Cars'
    },
    {
        permission: AdminPermissions.SendCarMessage,
        label: 'Message a car',
        description: 'Send a push notification to one car.',
        group: 'Messaging'
    },
    {
        permission: AdminPermissions.BroadcastDriverMessage,
        label: 'Broadcast to drivers',
        description: 'Send a push notification to every driver.',
        group: 'Messaging'
    },
    {
        permission: AdminPermissions.UpdatePos,
        label: 'Update POS',
        description: 'Edit POS settings, location and application version.',
        group: 'POS and vouchers'
    },
    {
        permission: AdminPermissions.ResetPosPairing,
        label: 'Reset POS pairing',
        description: 'Generate a new POS device pairing code.',
        group: 'POS and vouchers'
    },
    {
        permission: AdminPermissions.PayVoucher,
        label: 'Pay vouchers',
        description: 'Approve and pay pending vouchers.',
        group: 'POS and vouchers'
    },
    {
        permission: AdminPermissions.DeletePendingVouchers,
        label: 'Delete pending vouchers',
        description: 'Mark pending vouchers as deleted and hide them from the pending list.',
        group: 'POS and vouchers'
    },
    {
        permission: AdminPermissions.RestartKiosk,
        label: 'Restart kiosk',
        description: 'Restart the airport kiosk remotely.',
        group: 'Airport kiosk'
    },
    {
        permission: AdminPermissions.EditUsers,
        label: 'Edit users',
        description: 'Create users and edit their profile and permissions.',
        group: 'User management'
    },
    {
        permission: AdminPermissions.DeleteUser,
        label: 'Delete users',
        description: 'Permanently delete administrator accounts.',
        group: 'User management'
    },
    {
        permission: AdminPermissions.ResetPassword,
        label: 'Reset user passwords',
        description: 'Generate and save a new password for administrator accounts.',
        group: 'User management'
    }
];
